<template>
  <el-drawer
    title="待我审批"
    :visible.sync="drawer"
    destroy-on-close
    :modal-append-to-body="false"
    append-to-body
    :wrapperClosable="false"
    :custom-class="sidebarIsOpen ? 'width210' : 'width54'"
  >
    <div class="report">
      <el-tabs v-model="activeName" :stretch="false" class="tab_report">
        <el-tab-pane v-for="(item, index) in dataList" :key="index" :label="item.label" :name="item.activeCode">
          <component ref="componentRef" v-if="activeName === item.activeCode" :is="item.name" />
        </el-tab-pane>
      </el-tabs>
    </div>
    <flowReimbursementDetail ref="flowReimbursementDetail" :isExamine="isExamine" :applyOverviewId="applyOverviewId" />
    <flowVacationDetail ref="flowVacationDetail" :isExamine="isExamine" :applyOverviewId="applyOverviewId" />
    <flowTravelDetail ref="flowTravelDetail" :isExamine="isExamine" :applyOverviewId="applyOverviewId" />
    <flowMaterialDetail ref="flowMaterialDetail" :isExamine="isExamine" :applyOverviewId="applyOverviewId" />
    <flowApplyPre ref="flowApplyPre" :isExamine="isExamine" :applyOverviewId="applyOverviewId" />
    <flowApplyRefund ref="flowApplyRefund" :isExamine="isExamine" :applyOverviewId="applyOverviewId" />
    <flowUseSealInfoDTO ref="flowUseSealInfoDTO" :isExamine="isExamine" :applyOverviewId="applyOverviewId" />
    <materialPurchaseDTO ref="materialPurchaseDTO" :isExamine="isExamine" :applyOverviewId="applyOverviewId" />
    <flowMendDetailDTO ref="flowMendDetailDTO" :isExamine="isExamine" :applyOverviewId="applyOverviewId" />
    <flowApplyCommercePre ref="flowApplyCommercePre" :isExamine="isExamine" :applyOverviewId="applyOverviewId" />
    <flowApplyCommerceRefund ref="flowApplyCommerceRefund" :isExamine="isExamine" :applyOverviewId="applyOverviewId" />
    <VoidModuleCommerceRefund ref="VoidModuleCommerceRefund" :isExamine="isExamine" :applyOverviewId="applyOverviewId" />
       <PreviewList ref="PreviewList"  />
  </el-drawer>
</template>

<script>
import WaitingList from './components/WaitingList.vue'
import RecordList from './components/RecordList.vue'

import flowTravelDetail from '../initiateApproval/components/officialBusiness/components/Preview.vue'
import flowVacationDetail from '../initiateApproval/components/leaveApplication/components/preview.vue'
import flowMendDetailDTO from '../initiateApproval/components/cardReplacement/components/Preview.vue'
import flowReimbursementDetail from '../initiateApproval/components/expenseAccount/components/Preview.vue'
import flowUseSealInfoDTO from '../initiateApproval/components/applyWithSeal/components/Preview.vue'
import materialPurchaseDTO from '../initiateApproval/components/purchase/components/Preview.vue'
import flowApplyRefund from '../initiateApproval/components/refundApplication/components/Preview.vue'
import flowApplyPre from '../initiateApproval/components/discountApproval/components/Preview.vue'
import flowApplyCommercePre from '../initiateApproval/components/contractDiscounts/components/Preview.vue'
import flowMaterialDetail from '../initiateApproval/components/materialRequisition/components/Preview.vue'
import flowApplyCommerceRefund from '../initiateApproval/components/contractRefund/components/Preview.vue'
import VoidModuleCommerceRefund from '../initiateApproval/components/VoidModule/components/Preview.vue'
import PreviewList from '../initiateApproval/components/VoidModule/components/PreviewList.vue'
import { paymentDetail } from '@/api/finance' 
export default {
  components: {
    WaitingList,
    RecordList,
    flowReimbursementDetail,
    flowVacationDetail,
    flowTravelDetail,
    flowMaterialDetail,
    flowApplyPre,
    flowApplyRefund,
    flowUseSealInfoDTO,
    materialPurchaseDTO,
    flowMendDetailDTO,
    flowApplyCommercePre,
    flowApplyCommerceRefund,
    VoidModuleCommerceRefund,
    PreviewList,
 
  },
  data() {
    return {
      activeName: '10',
      drawer: false,
      isExamine: false,
      applyOverviewId: '',
    }
  },
  provide() {
    return {
      indexThis: this,
    }
  },
  computed: {
    dataList() {
      // const arr = []
      // if (this.hiddenTableColumn(['waitingListQuery'])) arr.push({ label: '待我审批', name: 'WaitingList', activeCode: '10' })
      // if (this.hiddenTableColumn(['recordListQuery'])) arr.push({ label: '审批记录', name: 'RecordList', activeCode: '20' })
      // if (arr.length) this.activeName = arr[0].activeCode
      return [
        { label: '待我审批', name: 'WaitingList', activeCode: '10' },
        { label: '审批记录', name: 'RecordList', activeCode: '20' },
      ]
    },
  },
  methods: {
    init() {
      this.$refs.componentRef[0].getList()
    },
         // 获取详情
    async paymentDetail(id) {
      const { data } = await paymentDetail({ id })
      if (!data) return
      this.$refs.PreviewList.previewForm = data.payment
      this.$refs.PreviewList.orderList = data.orderList
       this.$refs.PreviewList.payStatus = 10
      this.$refs.PreviewList.drawer = true
    },
  },
}
</script>

<style lang="less" scoped>
::v-deep .tableText {
  display: flex;
  justify-content: space-between;
  align-items: center;
  img {
    width: 10px;
    height: 10px;
  }
}

::v-deep .el-tabs__nav-wrap::after {
  position: static !important;
}
::v-deep .el-tabs__content .el-tab-pane {
  &::-webkit-scrollbar {
    display: none !important;
  }
}
@media (min-width: 1837px) and (max-width: 1920px) {
  ::v-deep .el-tabs__header {
    width: 55% !important;
  }
}
@media (min-width: 1714px) and (max-width: 1836px) {
  ::v-deep .el-tabs__header {
    width: 57% !important;
  }
}

@media (min-width: 1518px) and (max-width: 1713px) {
  ::v-deep .el-tabs__header {
    width: 61% !important;
  }
}
@media (min-width: 1364px) and (max-width: 1517px) {
  ::v-deep .el-tabs__header {
    width: 65% !important;
  }
}
@media (max-width: 1363px) {
  ::v-deep .el-tabs__header {
    width: 72% !important;
  }
}
@media (min-width: 1920px) {
  .tab_report {
    ::v-deep .el-tabs__active-bar {
      background-color: transparent !important;
      background-image: linear-gradient(90deg, transparent 0, transparent 30%, #31a8ff 0, #31a8ff 70%, transparent 0, transparent) !important;
    }
  }
}
@media (max-width: 1919px) {
  .tab_report {
    ::v-deep .el-tabs__active-bar {
      background-color: transparent !important;
      background-image: linear-gradient(90deg, transparent 0, transparent 35%, #31a8ff 0, #31a8ff 65%, transparent 0, transparent) !important;
    }
  }
}
::v-deep .el-tabs__item {
  color: #1d2129 !important;
  font-size: 16px !important;
  font-weight: 700;
  padding: 1.8518vh 1.0416vw !important;
}

::v-deep .el-tabs__header {
  margin: 0px !important;
}

::v-deep .communityId .el-input__inner {
  width: 232px;
}

.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 550px;
}

@media (min-width: 1689px) {
  ::v-deep .el-col-xl-2 {
    width: 5% !important;
  }
  ::v-deep .el-col-xl-6 {
    width: 19% !important;
  }
  ::v-deep .el-col-lg-14 {
    width: 30% !important;
  }
}
@media (min-width: 1400px) and (max-width: 1689px) {
  ::v-deep .el-col-xl-2 {
    width: 6% !important;
  }
  ::v-deep .el-col-xl-6 {
    width: 23% !important;
  }
  ::v-deep .el-col-lg-14 {
    width: 30% !important;
  }
  ::v-deep .el-row {
    margin-bottom: 0px;
  }
}
@media (min-width: 1340px) and (max-width: 1400px) {
  ::v-deep .el-col-xl-2 {
    width: 7% !important;
  }
  ::v-deep .el-col-xl-6 {
    width: 31% !important;
  }
  ::v-deep .el-col-lg-14 {
    width: 30% !important;
  }
  ::v-deep .el-row {
    margin-bottom: 0px;
  }
}
@media (min-width: 1158px) and (max-width: 1340px) {
  ::v-deep .el-col-xl-2 {
    width: 7% !important;
  }
  ::v-deep .el-col-xl-6 {
    width: 31% !important;
  }
  ::v-deep .el-col-lg-14 {
    width: 50% !important;
  }
  ::v-deep .el-row {
    margin-bottom: 0px;
  }
}
@media (max-width: 1158px) {
  ::v-deep .el-col-xl-2 {
    width: 7% !important;
  }
  ::v-deep .el-row {
    margin-bottom: 0px;
  }
}
@media (min-width: 1200px) and (max-width: 1411px) {
  ::v-deep .el-col-lg-12 {
    width: 56% !important;
  }
}
@media (min-width: 1412px) and (max-width: 1555px) {
  ::v-deep .el-col-lg-12 {
    width: 45% !important;
  }
}
@media (min-width: 1556px) and (max-width: 1791px) {
  ::v-deep .el-col-lg-12 {
    width: 40% !important;
  }
}
::v-deep .el-form-item__content {
  width: 72% !important;
}
::v-deep .el-card {
  margin-bottom: 0px !important;
  .el-card__body {
    padding: 24px 0.8333vw !important;
  }
}

@media only screen and (max-width: 1780px) {
  ::v-deep .el-col-lg-24 {
    width: 98% !important;
  }
  ::v-deep .bottom {
    .box {
      height: inherit !important;
    }
    .chartBox {
      height: 41vh !important;
    }
  }
}

@media only screen and (min-width: 1781px) {
  ::v-deep .el-col-lg-24 {
    width: 48% !important;
  }
  ::v-deep .bottom {
    .box {
      height: 420px !important;
    }
  }
}
@media only screen and (min-width: 1920px) {
  ::v-deep .el-col-xl-12 {
    width: 48% !important;
  }
  ::v-deep .bottom {
    .box {
      height: 420px !important;
    }
  }
}

// ::v-deep .el-table .el-table__cell{
//   padding: 0.926vh 0 !important;
// }
</style>
